module.exports = __webpack_public_path__ + "img/line.1dde0d03.png";